<template>
  <div class="search mb-6">
    <el-collapse accordion @change="changeAccordion">
      <el-collapse-item>
        <template slot="title">
          <div class="searchItem">
            <p class="searchLabel">归属代理商</p>
            <div class="searchInfo">
              <el-radio-group v-model="radio" @change="changeAgent">
                <el-radio-button label="0">全部</el-radio-button>
                <el-radio-button label="1">自定义</el-radio-button>
              </el-radio-group>
            </div>
            <el-form
              v-show="radio == '1'"
              :model="formes"
              ref="ruleForm"
              style="margin-left: 1px"
            >
              <el-form-item prop="agent_id">
                <el-select
                  v-model="formes.agent_id"
                  filterable
                  placeholder="请输入代理商名称"
                  style="width: 260px"
                  size="small"
                  @change="changeAgent"
                  clearable
                >
                  <el-option
                    v-for="item in agentData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <span style="position: absolute; right: 50px"
            >点击{{ accordiondisable ? "展开" : "折叠" }}</span
          >
        </template>
        <div class="searchItem">
          <p class="searchLabel">企业</p>
          <div class="searchInfo">
            <el-radio-group v-model="radio2" @change="changeCompany">
              <el-radio-button label="0">全部</el-radio-button>
              <el-radio-button label="1">自定义</el-radio-button>
            </el-radio-group>
          </div>
          <el-form
            v-show="radio2 == '1'"
            :model="formes"
            ref="ruleForm"
            style="margin-left: 1px"
          >
            <el-form-item prop="company_id">
              <el-select
                v-model="formes.company_id"
                filterable
                placeholder="请输入企业名称"
                style="width: 260px"
                size="small"
                @change="changeCompany"
                clearable
              >
                <el-option
                  v-for="item in companyData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="searchItem">
          <p class="searchLabel">统计日期</p>
          <div class="searchInfo">
            <el-radio-group v-model="date" @change="changeDate">
              <el-radio-button label="2">全部</el-radio-button>
              <el-radio-button label="1">今天</el-radio-button>
              <el-radio-button label="-1">昨天</el-radio-button>
              <el-radio-button label="7">本周</el-radio-button>
              <el-radio-button label="30">最近一个月</el-radio-button>
              <el-radio-button label="90">最近三个月</el-radio-button>
              <el-radio-button label="0">自定义</el-radio-button>
            </el-radio-group>
            <el-date-picker
              v-show="date == 0"
              v-model="value"
              size="small"
              type="daterange"
              align="right"
              value-format="yyyy-MM-dd"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              style="width: 300px"
              @change="timeget"
            ></el-date-picker>
          </div>
        </div>
        <!-- <div class="searchItem">
      <p class="searchLabel">呼叫方式</p>
      <div class="searchInfo">
        <el-radio-group v-model="call_type_id" @change="changeCallType">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">A直呼</el-radio-button>
          <el-radio-button label="2">X直呼</el-radio-button>
          <el-radio-button label="3">AA呼转</el-radio-button>
          <el-radio-button label="4">AX呼转</el-radio-button>
          <el-radio-button label="5">XX呼转</el-radio-button>
        </el-radio-group>
      </div>
    </div> -->
        <div class="searchItem">
          <p class="searchLabel">录音</p>
          <div class="searchInfo">
            <el-radio-group v-model="recording" @change="changeRecord">
              <el-radio-button label="2">全部</el-radio-button>
              <el-radio-button label="1">有录音</el-radio-button>
              <el-radio-button label="0">无录音</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="searchItem">
          <p class="searchLabel">状态</p>
          <div class="searchInfo">
            <el-radio-group v-model="status" @change="changeStatus">
              <el-radio-button label="0">全部</el-radio-button>
              <el-radio-button label="1">未拨打</el-radio-button>
              <el-radio-button label="2">已拨打</el-radio-button>
              <el-radio-button label="3">已接通</el-radio-button>
              <el-radio-button label="4">未接通</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="searchItem">
          <p class="searchLabel">通话时长</p>
          <div class="searchInfo">
            <el-radio-group v-model="calltimes" @change="changeCall">
              <el-radio-button label="7">全部</el-radio-button>
              <!-- <el-radio-button label="0">0秒</el-radio-button> -->
              <el-radio-button label="1">1-10秒</el-radio-button>
              <el-radio-button label="2">11-30秒</el-radio-button>
              <el-radio-button label="3">31-60秒</el-radio-button>
              <el-radio-button label="4">61-120秒</el-radio-button>
              <el-radio-button label="5">120秒以上</el-radio-button>
              <el-radio-button label="6">自定义</el-radio-button>
            </el-radio-group>
            <div
              v-show="this.calltimes == 6"
              class="searchInfo"
              style="margin-left: -43px; display: flex"
            >
              <div class="searchInput">
                <input
                  type="text"
                  name="points"
                  v-model="calltimes1"
                  maxlength="10"
                  oninput="javascript:this.value=this.value.replace(/[^\d]/g,'')"
                />
                <span class="searchInputIcon">-</span>
                <input
                  type="text"
                  name="points"
                  v-model="calltimes2"
                  maxlength="10"
                  oninput="javascript:this.value=this.value.replace(/[^\d]/g,'')"
                />
              </div>
              <span class="searchInputDesc">秒</span>
              <el-button size="small" @click="changeTime">确定</el-button>
            </div>
          </div>
        </div>
        <!-- <div class="searchItem">
      <p class="searchLabel">自动质检</p>
      <div class="searchInfo">
        <el-radio-group v-model="is_pass" @change="changeIsPass">
          <el-radio-button label="-1">全部</el-radio-button>
          <el-radio-button label="0">不通过</el-radio-button>
        </el-radio-group>
      </div>
    </div> -->
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { getData, postData } from "@/api/index";
import moment from "moment";
export default {
  props: {
    reduct: Boolean,
  },
  data() {
    return {
      formes: {},
      agentData: [],
      date: "2",
      radio: "0",
      radio2: "0",
      recording: "2",
      // is_pass: "-1",
      status: "0",
      calltimes1: "",
      calltimes2: "",
      call_type_id: 0,
      calltimes: "7",
      calltimeArr: [
        [1, 10],
        [11, 30],
        [31, 60],
        [61, 120],
        [120, 8640000],
      ],
      value: [],
      companyData: [],
      accordiondisable: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.getAgentData();
    this.getCompanyData();
    this.Reduction();
  },
  watch: {
    reduct() {
      if (this.reduct) {
        this.Reduction();
      }
    },
  },
  methods: {
    changeAccordion() {
      this.accordiondisable = !this.accordiondisable;
      if (this.accordiondisable) {
        this.offhight = 0;
      } else {
        this.offhight = 205;
      }
      this.$emit("changeAccordion", this.offhight);
    },
    changeCompany() {
      if (this.radio2 !== "1") {
        delete this.formes.company_id;
        this.esarchang();
      } else {
        if (this.formes.company_id == "") {
          delete this.formes.company_id;
          this.esarchang();
        } else {
          this.esarchang();
        }
      }
    },
    getDateStr(now) {
      var year = now.getFullYear(); // 年
      var month = now.getMonth() + 1; // 月
      var day = now.getDate(); // 日
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return year + "-" + month + "-" + day;
    },
    Reduction() {
      this.radio = "0";
      this.radio2 = "0";
      this.date = "2";
      // this.is_pass = "-1";
      this.value = [];
      this.call_type_id = 0;
      this.recording = "2";
      this.status = "0";
      this.calltimes = "7";
      this.calltimes1 = "";
      this.calltimes2 = "";
      this.changeDate();
      this.$emit("onreduction");
    },
    changeIsPass() {
      if (this.is_pass == "-1") {
        delete this.formes.is_pass;
      } else {
        this.formes.is_pass = this.is_pass;
      }
      this.esarchang();
    },
    changeAgent() {
      if (this.radio !== "1") {
        delete this.formes.agent_id;
        this.esarchang();
      } else {
        if (this.formes.agent_id == "") {
          delete this.formes.agent_id;
          this.esarchang();
        } else {
          this.esarchang();
        }
      }
    },
    timeget(val) {
      if (val !== null) {
        this.formes.s_created_at = val[0];
        this.formes.e_created_at = val[1];
      } else {
        this.value = [];
        delete this.formes.s_created_at;
        delete this.formes.e_created_at;
      }
      this.esarchang();
    },
    calculationTime(num) {
      const end = moment().format("YYYY-MM-DD");
      const start = new Date();
      if (num == "-1") {
        start.setTime(start.getTime() - 3600 * 1000 * 24);
        return [
          moment(start).format("YYYY-MM-DD"),
          moment(start).format("YYYY-MM-DD"),
        ];
      } else if (num == "1") {
        start.setTime(start.getTime());
        return [end, moment(start).format("YYYY-MM-DD")];
      } else if (num == "7") {
        var now = new Date();
        var nowDayOfWeek = now.getDay() == 0 ? 6 : now.getDay() - 1;
        var startTime = this.getDateStr(
          new Date(now.getTime() - nowDayOfWeek * 24 * 60 * 60 * 1000)
        );
        var endTime = this.getDateStr(now);
        return [startTime, endTime];
      } else {
        let end = new Date().getTime();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * num);
        return [
          moment(start).format("YYYY-MM-DD"),
          moment(end).format("YYYY-MM-DD"),
        ];
      }
    },
    returnDate() {
      let arr = [];
      arr = this.calculationTime(this.date);
      arr[0] = arr[0] + " 00:00:00";
      arr[1] = arr[1] + " 23:59:59";
      this.timeget(arr);
    },
    async changeDate() {
      if (this.date !== "0") {
        if (this.date !== "2") {
          await this.returnDate();
        } else {
          delete this.formes.s_created_at;
          delete this.formes.e_created_at;
          this.esarchang();
        }
      } else {
        delete this.formes.date;
      }
    },
    changeCallType() {
      if (this.call_type_id !== 0) {
        this.formes.call_type_id = this.call_type_id;
      } else {
        delete this.formes.call_type_id;
      }
      this.esarchang();
    },
    changeRecord() {
      if (this.recording !== "2") {
        this.formes.recording = this.recording;
      } else {
        delete this.formes.recording;
      }
      this.esarchang();
    },
    changeStatus() {
      if (this.status !== "0") {
        this.formes.status = this.status;
      } else {
        delete this.formes.status;
      }
      this.esarchang();
    },
    callTime(num) {
      return this.calltimeArr[num * 1 - 1];
    },
    changeTime() {
      if (this.calltimes1 && this.calltimes2) {
        let num1 = Number(this.calltimes1);
        let num2 = Number(this.calltimes2);
        if (num2 >= num1) {
          [this.formes.s_use_time, this.formes.e_use_time] = [num1, num2];
          this.esarchang();
        } else {
          return this.$message.warning("输入的时间必须后一个大于等于前一个");
        }
      } else {
        return this.$message.warning("请填写完整的时间区间");
      }
    },
    changeCall() {
      if (this.calltimes !== "6") {
        if (this.calltimes == "7") {
          delete this.formes.s_use_time;
          delete this.formes.e_use_time;
        } else {
          [this.formes.s_use_time, this.formes.e_use_time] = this.callTime(
            this.calltimes
          );
        }
        this.esarchang();
      }
    },
    esarchang() {
      this.$emit("eserach", this.formes);
    },
    getAgentData() {
      let params = {
        page: 1,
        role: 2,
        pagesize: 10000,
      };
      getData("UserController/pageAction", params).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.agentData = res.data.data;
      });
    },
    getCompanyData() {
      let params = {
        page: 1,
        pagesize: 10000,
      };
      getData("company.CompanyController/pageAction", params).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.companyData = res.data.data;
      });
    },
  },
};
</script>
<style lang="less" src="@/assets/css/records.less" scoped></style>
<style src="@/assets/css/index.css" scoped></style>
<style lang="less" scoped>
/deep/ .el-collapse-item__header.is-active {
  border-bottom: 1px solid #eee;
}
/deep/ .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
}
/deep/ .el-collapse {
  border-top: none;
  border-bottom: none;
}
/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}
</style>
